module.exports = __webpack_public_path__ + "img/MZ.5a4a3d84.svg";